export const FETCH_DEBITNOTES = 'FETCH_DEBITNOTES';
export const PUSH_DEBITNOTES = 'PUSH_DEBITNOTES';
export const REMOVE_DEBITNOTES = 'REMOVE_DEBITNOTES';
export const UPDATE_DEBITNOTES = 'UPDATE_DEBITNOTES';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_ACTIVE_ID = 'UPDATE_ACTIVE_ID';

export function fetchDebitNotes(data){
  return (dispatch) => {
    dispatch({
      type: FETCH_DEBITNOTES,
      payload:data
    });
  }
}

export function pushDebitNotes(data){
  return (dispatch) => {
    dispatch({
      type: PUSH_DEBITNOTES,
      payload:data
    });
  }
}

export function removeDebitNotes(data){
  return (dispatch) => {
    dispatch({
      type: REMOVE_DEBITNOTES,
      payload:data
    });
  }
}

export function updateDebitNotes(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_DEBITNOTES,
      payload:data
    });
  }
}

export function updateMode(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODE,
      payload:data
    });
  }
}

export function updateActiveDebitNotes(mode, id){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_ID,
      mode,
      id
    });
  }
}
